/*
 * Imperative confirm() — promise-based replacement for window.confirm().
 *
 * Usage anywhere:
 *   import { confirm } from '@/lib/confirm';
 *   const ok = await confirm({
 *     title: 'Delete user',
 *     message: 'This cannot be undone.',
 *     confirmText: 'Delete',
 *     destructive: true,
 *   });
 *   if (!ok) return;
 *
 * The provider (ConfirmProvider) must be mounted at the top of the React tree.
 * Until it is, calls resolve to `false` so callers safely short-circuit
 * destructive actions instead of acting on an unmounted UI.
 */
let _impl = () => Promise.resolve(false);

export const confirm = (options) => _impl(options);

// Internal — set by ConfirmProvider on mount, cleared on unmount.
export const __setConfirmImpl = (fn) => {
  _impl = fn || (() => Promise.resolve(false));
};
